/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JourneyType,
    JourneyTypeFromJSON,
    JourneyTypeFromJSONTyped,
    JourneyTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface JourneyTypeCriteriaInput
 */
export interface JourneyTypeCriteriaInput {
    /**
     * 
     * @type {boolean}
     * @memberof JourneyTypeCriteriaInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {JourneyType}
     * @memberof JourneyTypeCriteriaInput
     */
    value?: JourneyType;
}

export function JourneyTypeCriteriaInputFromJSON(json: any): JourneyTypeCriteriaInput {
    return JourneyTypeCriteriaInputFromJSONTyped(json, false);
}

export function JourneyTypeCriteriaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneyTypeCriteriaInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : JourneyTypeFromJSON(json['value']),
    };
}

export function JourneyTypeCriteriaInputToJSON(value?: JourneyTypeCriteriaInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': JourneyTypeToJSON(value.value),
    };
}


